<template>
  <div v-if="task">
    <task-body :task="task" :try-join="tryJoin" :try-leave="tryLeave" />
    <box class="pb-4">
      <h3 class="mb-5">{{ $tc('reward', 2) }}</h3>
      <div class="mb-1">
        <masonry :cols="{ default: 3, 1200: 2, 992: 1 }" :gutter="20">
          <reward icon="follow" title="Join" disabled-limits class="mb-4">
            <strong>{{ task.subTasks.join.stakes }} stakes</strong> / week
          </reward>
          <reward icon="user" title="Avatar" disabled-limits class="mb-4">
            <strong>{{ task.subTasks.avatar.stakes }} stakes</strong> / week
          </reward>
          <reward icon="post" title="Text in bio" disabled-limits class="mb-4">
            <strong>{{ task.subTasks.textInBio.stakes }} stakes</strong> / week
          </reward>
          <reward icon="post" title="Text in name" disabled-limits class="mb-4">
            <strong>{{ task.subTasks.textInName.stakes }} stakes</strong> / week
          </reward>
        </masonry>
      </div>
      <h3 class="mb-5 mt-5">Telegram activity rewards</h3>
      <b-row>
        <b-col md="12" lg="6" xl="4">
          <reward
            icon="comment-o"
            title="Weekly stakes"
            disabled-limits
            class="mb-4"
          >
            <strong>25 stakes</strong> / week
          </reward>
        </b-col>
      </b-row>
    </box>
  </div>
</template>

<script>
import taskMixin from './../../mixins/task.js';
import RewardsList from '@/views/Campaign/BountyCampaign/components/RewardsList.vue';

export default {
  mixins: [taskMixin],

  components: {
    RewardsList
  }
};
</script>
